import { render, staticRenderFns } from "./event-chart.vue?vue&type=template&id=87b1f912&"
import script from "./event-chart.vue?vue&type=script&lang=js&"
export * from "./event-chart.vue?vue&type=script&lang=js&"
import style0 from "./event-chart.vue?vue&type=style&index=0&id=87b1f912&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports